export default "__VITE_ASSET__BQCq_69x__"